/**
 * To optimize imports, we need to include used icons here, and thus we can
 * reference them directly by string without having to manually import every
 * icon in every component that uses them.
 * @see https://github.com/FortAwesome/react-fontawesome#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
 * @see Search available icons: https://fontawesome.com/icons?d=gallery&s=regular,solid
 */

import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faGooglePlay,
	faAppStoreIos,
} from '@fortawesome/free-brands-svg-icons'

import {
	faBookOpen as farBookOpen,
	faCalendar,
	faCalendarAlt,
	faCalendarEdit,
	faClock,
	faMoneyCheckEditAlt,
	faStar as faStarEmpty,
} from '@fortawesome/pro-regular-svg-icons'

import {
	faAlarmExclamation,
	faAngleDown,
	faAsterisk,
	faBan,
	faBars,
	faBell,
	faBellSlash,
	faBookOpen,
	faCalendarDay,
	faCamera,
	faCarSide,
	faCarOn,
	faCheck,
	faChevronLeft,
	faChevronRight,
	faCog,
	faCircle,
	faCircleCheck,
	faCircleInfo,
	faCommentDots,
	faCommentsQuestion,
	faCompressArrowsAlt,
	faCreditCard,
	faCut,
	faDoorOpen,
	faDownload,
	faEdit,
	faEllipsisH,
	faEllipsisV,
	faEnvelope,
	faEraser,
	faExclamationCircle,
	faExclamationTriangle,
	faEye,
	faEyeSlash,
	faFax,
	faFileInvoiceDollar,
	faFilePdf,
	faHandHoldingDollar,
	faHistory,
	faImage,
	faImages,
	faKey,
	faList,
	faMapMarkedAlt,
	faMapMarkerAlt,
	faMapMarkerExclamation,
	faMinus,
	faMinusOctagon,
	faMoneyBillWave,
	faMugHot,
	faOctagonXmark,
	faPaperPlane,
	faPencilAlt,
	faPennant,
	faPhoneAlt,
	faPlateUtensils,
	faPlay,
	faPlus,
	faPlusCircle,
	faPowerOff,
	faPrint,
	faPrintSearch,
	faQuestionCircle,
	faReceipt,
	faRecycle,
	faRedo,
	faSave,
	faScroll,
	faSearch,
	faShoppingBag,
	faSignOut,
	faSlash,
	faSms,
	faSpinner,
	faStar as faStarSolid,
	faStop,
	faStore,
	faStoreAlt,
	faStream,
	faSync,
	faTabletAlt,
	faThumbtack,
	faTicketAlt,
	faTimes,
	faToggleOn,
	faTrash,
	faTrashUndo,
	faTruck,
	faUndo,
	faUndoAlt,
	faUser,
	faUserFriends,
	faUserTag,
	faWalking,
	faWifiSlash,
	faWindowClose,
} from '@fortawesome/pro-solid-svg-icons'

library.add(
	faAlarmExclamation,
	faAngleDown,
	faAppStoreIos,
	faAsterisk,
	faBan,
	faBars,
	faBell,
	faBellSlash,
	faBookOpen,
	farBookOpen,
	faCalendar,
	faCalendarAlt,
	faCalendarDay,
	faCalendarEdit,
	faCamera,
	faCarSide,
	faCarOn,
	faCheck,
	faChevronLeft,
	faChevronRight,
	faClock,
	faCog,
	faCircle,
	faCircleCheck,
	faCircleInfo,
	faCommentDots,
	faCommentsQuestion,
	faCompressArrowsAlt,
	faCreditCard,
	faCut,
	faDoorOpen,
	faDownload,
	faEdit,
	faEllipsisH,
	faEllipsisV,
	faEnvelope,
	faEraser,
	faExclamationCircle,
	faExclamationTriangle,
	faEye,
	faEyeSlash,
	faFax,
	faFileInvoiceDollar,
	faFilePdf,
	faGooglePlay,
	faHandHoldingDollar,
	faHistory,
	faImage,
	faImages,
	faKey,
	faList,
	faMapMarkedAlt,
	faMapMarkerAlt,
	faMapMarkerExclamation,
	faMinus,
	faMoneyBillWave,
	faMugHot,
	faMoneyCheckEditAlt,
	faOctagonXmark,
	faPaperPlane,
	faPencilAlt,
	faPennant,
	faPhoneAlt,
	faPlateUtensils,
	faPlay,
	faPlus,
	faPlusCircle,
	faPowerOff,
	faPrint,
	faPrintSearch,
	faQuestionCircle,
	faRecycle,
	faReceipt,
	faRedo,
	faSave,
	faScroll,
	faSearch,
	faShoppingBag,
	faSignOut,
	faSlash,
	faSms,
	faSpinner,
	faStarEmpty,
	faStarSolid,
	faStop,
	faStore, //make-believe for Google My Business
	faStoreAlt, //used at Auth::CANNED_MESSAGES for user messaging
	faStream,
	faSync,
	faTabletAlt,
	faThumbtack,
	faTicketAlt,
	faTimes,
	faToggleOn,
	faTrash,
	faTrashUndo,
	faTruck,
	faUndo,
	faUndoAlt,
	faUser,
	faUserFriends,
	faUserTag,
	faWalking,
	faWifiSlash,
	faWindowClose,
	faMinusOctagon,
)
